<main>
  <div class="position-relative">
    <!-- shape Hero -->
    <section class="section section-lg section-shaped pb-250 header-filter">
      <div class="container py-lg-md d-flex mt-5">
        <div class="col px-0">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-6 text-center">
              <!-- infinite loop -->
              <ngx-typed-js
                [strings]="[' Products']"
                [loop]="true"
                [stringsElement]="null"
                [typeSpeed]="100"
                [startDelay]="1200"
                [backSpeed]="100"
                [backDelay]="150"
                [loop]="true"
                [loopCount]="false"
                [showCursor]="false"
                [fadeOut]="true"
                (completed)="doSmth()"
              >
                <h1 class="display-1 text-white pre">
                  Our best <span class="typing"></span>
                </h1>
              </ngx-typed-js>
              <!-- <h1 class="display-3 text-white">
                Our Best Services
              </h1> -->
              <p class="lead text-white">
                A Complete Solution for your Digital Vision.
                <!-- Our any Creative Project Unique and should be provided with
                appropriate quality. We have one stop solution in Software
                Industries. -->
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- SVG separator -->
      <div class="separator separator-bottom separator-skew">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </section>
    <!-- 1st Hero Variation -->
  </div>

  <section class="service-details section section-lg pt-lg-0 mt--200">
    <div class="container">
      <div class="row">
        <div
          *ngFor="let arr of data"
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img [src]="arr.imageUrl" alt="..." />
            </div>
            <div class="card-body icon-webdig">
              <i class="icon-featured text-white"
                ><img [src]="arr.productIcon" alt="" srcset=""
              /></i>
              <h5 class="card-title">{{ arr.productName }}</h5>
              <p class="card-text">
                {{ arr.productDes }}
              </p>
              <div class="read-more">
                <a routerLink="/service/website-designing"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>

        <!-- <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-2.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-webdev">
              <i class="icon-featured fa fa-gear"></i>
              <h5 class="card-title">Website Development</h5>
              <p class="card-text">
                A website represents a comapny and their brands on...
              </p>
              <div class="read-more">
                <a routerLink="/service/website-development"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-3.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-e-comm">
              <i class="icon-featured fa fa-shopping-cart"></i>
              <h5 class="card-title">E-commerce Solution</h5>
              <p class="card-text">
                E-Commerce means buying and selling of goods and services online
                over....
              </p>
              <div class="read-more">
                <a routerLink="/service/ecommerce-solution"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-mob">
              <i class="icon-featured fa fa-mobile"></i>
              <h5 class="card-title">Mobile Applications</h5>
              <p class="card-text">
                Mobile applications development always requires advance
                inovative thinking and...
              </p>
              <div class="read-more">
                <a routerLink="/service/mobile-application"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-social">
              <i class="icon-featured fa fa-life-bouy"></i>
              <h5 class="card-title">Social Applications</h5>
              <p class="card-text">
                We are in the field of complete social network application
                development...
              </p>
              <div class="read-more">
                <a routerLink="/service/social-application"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-dig">
              <i class="icon-featured fa fa-line-chart"></i>
              <h5 class="card-title">Digital Marketing</h5>
              <p class="card-text">
                Digital marketing encompasses all marketing efforts that use an
                electronic device or the internet. Businesses ...
              </p>
              <div class="read-more">
                <a routerLink="/service/digital-marketing"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-soft">
              <i class="icon-featured fa fa-cogs"></i>
              <h5 class="card-title">Software Development</h5>
              <p class="card-text">
                WEB CARE SOFTWARE is engaged in custom software development
                for...
              </p>
              <div class="read-more">
                <a routerLink="/service/software-development"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-mult">
              <i class="icon-featured fa fa-life-saver"></i>
              <h5 class="card-title">Multimedia Solution</h5>
              <p class="card-text">
                WEB CARE SOFTWARES is the top Animation development company
                based in india we...
              </p>
              <div class="read-more">
                <a routerLink="/service/multimedia-solution"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-lg-4 d-flex align-items-stretch"
          data-aos="fade-up"
        >
          <div class="card featured-box featured-box-effect-1">
            <div class="card-img">
              <img
                src="../../../../../assets/img/pages/services/service-details-4.jpg"
                alt="..."
              />
            </div>
            <div class="card-body icon-host">
              <i class="icon-featured fa fa-cloud"></i>
              <h5 class="card-title">Web Hosting Services</h5>
              <p class="card-text">
                We are one of the best web hosting services provider include...
              </p>
              <div class="read-more">
                <a routerLink="/service/web-hosting-services"
                  ><i class="icofont-arrow-right"></i> Read More</a
                >
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
  <!-- Call to action -->
  <section class="section pt-0" data-aos="zoom-in" data-aos-delay="800">
    <div class="container">
      <div class="card bg-gradient-warning shadow-lg border-0">
        <div class="p-5">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <h3 class="text-white">
                Drive your online business to success.
              </h3>
              <p class="lead text-white mt-3">
                Contact us now to know all about our brilliant offerings
              </p>
            </div>
            <div class="col-lg-3 ml-lg-auto">
              <a
                href="javascript:void(0)"
                class="btn btn-lg btn-block btn-white"
                >Get In Touch</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
